import React from "react";

interface ResultsGroupProps {
  legend: string;
  children: React.ReactNode;
  className?: string;
}

const ResultsGroup: React.FC<ResultsGroupProps> = ({
  legend,
  children,
  className,
}) => {
  return (
    <fieldset className={`results-group ${className || ""}`}>
      <legend className="results-group-legend">{legend}</legend>
      {children}
    </fieldset>
  );
};

export default ResultsGroup;
